import { render, staticRenderFns } from "./pageHero.vue?vue&type=template&id=3d2fe98e&scoped=true"
import script from "./pageHero.vue?vue&type=script&lang=js"
export * from "./pageHero.vue?vue&type=script&lang=js"
import style0 from "./pageHero.vue?vue&type=style&index=0&id=3d2fe98e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d2fe98e",
  null
  
)

export default component.exports